/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { postToController } from '../../actions/apiActions';
import { navigateTo } from '../../actions/navigationActions';
import { submitClaimMobile, setLocation, setTimeShow, setDate, setTime, setStep, setIsCar, getClaimDamagePhotoTypes, setSelectedDamagePhotoTypes, setDamagePosition, setSelectedAllTrue, setSelectedAllFalse, setIsInEdit, getDateString, checkDateTime } from '../../actions/claimSubmitActions';
import { Dropdown, Image } from 'react-bootstrap';
import { SUBMIT_CLAIM_DETAILS,  SUBMIT_CLAIM } from '../../routes/routes';
import { GoogleApiWrapper } from 'google-maps-react';
import { FNOL, DASHBOARD } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import '../TimePicker/TimePicker.css';
import {
    geocodeByAddress,
    getLatLng
} from 'react-places-autocomplete';
import './FNOL.css';
import { showDrivableNoModal, showSelectedDamageCar, showSelectedDamageMB } from '../../actions/modalActions';
import ModernDatepicker from 'react-modern-datepicker';
import TimeKeeper from 'react-timekeeper';
import FnolStep1 from './FnolSteps/FnolStep1Overview';
import FnolStep2 from './FnolSteps/FnolStep2Where';

var lat = null
var lng = null

class ClaimDetails extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            eventTypeList: null,
            selectedCover: null,
            selectedEvent: null,
            incidentTypeList: null,
            selectedIncidentType: null,
            coverToggle: false,
            IncidentToggle: false,
            IncidentTypeToggle: false,
            indidentDate: '12:00pm',
            IsIncidentDateClicked: false,
            incidentDescriptionWhere: "",
            incidentDescriptionWhat: "",
            currentStep: 2,
            nextDisabled: true,
            submitDisabled: true,
            DescriptionWhereDisabled: false,
            DescriptionWhereSubmitted: false,
            DescriptionWhatDisabled: false,
            DescriptionWhatSubmitted: false,
            showMarker: false,
            claimNumber: "",
            carDriveableSet: false,
            isDriveable: false,
            carRecoveredSet: false,
            isRecovered: false,
            carRecoveredValidationVisible: false,
            carDriveableValidationVisible: false,
            name: this.props.profile.name + " " + this.props.profile.surname,
            contact: this.props.profile.cellphoneNumber,
            selectedIncidentTypeValidationVisible: false,
            incidentDescriptionValidationVisible: false,
            nameValidationVisible: false,
            contactValidationVisible: false,
            lat: 0,
            lng: 0,
            isCar: false,
            hasCause: false,
            hasDate: false,
            hasTime: false,
            Step1Disabled: false,
            Step1Submitted: false,
            startDate: "",
            maxDate: new Date(),
            time12: props.time,
            time24: null,
            causeOfCollision: "",
            damageIsInEdit: false,
            modalDamagePhotoTypes: [],
            carDamageExtras: ["Undercarriage damage", "Interior", "Airbag popped", "Sunroof", "Roof", "Locks"],
            mbDamageExtras: ["Seat", "Sprocket", "Gas tank", "Frame", "Passenger seat", "Chain", "Engine", "Drive train", "Instruments", "Suspension"],
            mouseOut: false,
            isClosed: false,
            hasFutureDate: false,
            hasFutureTime: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleNextMobile = this.handleNextMobile.bind(this);
        this.handleCoverSelection = this.handleCoverSelection.bind(this);
        this.handleIncidentTypeDropdownToggle = this.handleIncidentTypeDropdownToggle.bind(this);
        this.handleCoverDropdownToggle = this.handleCoverDropdownToggle.bind(this);
        this.handleIncidentSelection = this.handleIncidentSelection.bind(this);
        this.handleIncidentToggle = this.handleIncidentToggle.bind(this);
        this.handleIndidentDateClicked = this.handleIndidentDateClicked.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleIncidentEventTypeSelection = this.handleIncidentEventTypeSelection.bind(this);
        this.handeCanDrive = this.handeCanDrive.bind(this);
        this.handeCanRecover = this.handeCanRecover.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeDescriptionWhere = this.handleChangeDescriptionWhere.bind(this);
        this.handleChangeDescriptionWhat = this.handleChangeDescriptionWhat.bind(this);
        this.Submit = this.Submit.bind(this);
        this.mapReady = this.mapReady.bind(this);
        this.handleAdressSelect = this.handleAdressSelect.bind(this);
        this.handleAdressChange = this.handleAdressChange.bind(this);
        this.updateLatLngAdress = this.updateLatLngAdress.bind(this);
        this.handleIsDrivable = this.handleIsDrivable.bind(this);
        this.handleStepBack = this.handleStepBack.bind(this);
        this.handleChangeDateValue = this.handleChangeDateValue.bind(this);
        //this.handleChangeCause = this.handleChangeCause.bind(this);
        //this.handleStep1Submit = this.handleStep1Submit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        //this.handleChangeCause = this.handleChangeCause.bind(this);
        this.handleChangeDescriptionWhat = this.handleChangeDescriptionWhat.bind(this);
        this.handleChangeDateValue = this.handleChangeDateValue.bind(this);
        this.setTime = this.setTime.bind(this);
        this.handleChangeDateValue = this.handleChangeDateValue.bind(this);
        this.selectCauseOfCollision = this.selectCauseOfCollision.bind(this);
        this.handleStep1Submit = this.handleStep1Submit.bind(this);
        this.handleIsDrivableYes = this.handleIsDrivableYes.bind(this);
        this.handleEditSelectedDamage = this.handleEditSelectedDamage.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleSubmitDamageStep1 = this.handleSubmitDamageStep1.bind(this);
        this.checkDamageExtras = this.checkDamageExtras.bind(this);
        this.checkChecked = this.checkChecked.bind(this);
        this.handleChangeStep1 = this.handleChangeStep1.bind(this);
        this.checkSubmitDescriptionWhere = this.checkSubmitDescriptionWhere.bind(this);
        this.checkWhatSubmit = this.checkWhatSubmit.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleResetStep = this.handleResetStep.bind(this);
        this.checkTimeToggle = this.checkTimeToggle.bind(this);
        this.setMouseOut = this.setMouseOut.bind(this);
        this.setMouseIn = this.setMouseIn.bind(this);
        this.listenAwayClick = this.listenAwayClick.bind(this);
        this.handleClickAway = this.handleClickAway.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
    }

    async setMouseOut() {
        await this.setState({ mouseOut: true });
        this.listenAwayClick();
    }

    async setMouseIn() {
        await this.setState({ mouseOut: false });
        this.listenAwayClick();
    }

    async handleClickAway() {
        document.body.removeEventListener("click", this.handleClickAway);
        this.setState({
            isClosed: true,
        })
        if (this.state.hasTime) {
            await this.setTime(this.state.time12, this.state.time24);
        }
        else {
            this.props.dispatchSetTimeShow();
        }
    }

    async handleTimeChange(f12: any, f24: any) {
        this.setState({ hasTime: true });
        await this.setState({ time12: f12, time24: f24 });
    }

    listenAwayClick() {
        if (this.state.mouseOut && !this.state.isClosed) {
            document.body.addEventListener("click",  this.handleClickAway);
        }
        else {
            document.body.removeEventListener("click", this.handleClickAway);
        }
    }

    checkTimeToggle() {
        if (this.props.claimSubmit.IsIncidentDateClicked) {
            this.props.dispatchSetTimeShow();
        }
    }

    handleNextStep() {
        let nextStep = this.props.claimSubmit.selectedClaimStep.step;
        let nextSubStep = this.props.claimSubmit.selectedClaimStep.subStep;
        let currentStep = this.props.claimSubmit.selectedClaimStep.step;
        if (this.props.claimSubmit.selectedClaimStep.stepConfiguration[currentStep - 1].maxSubSteps === this.props.claimSubmit.selectedClaimStep.subStep) {
            nextSubStep = 1;
            nextStep++;
        }
        else {
            nextSubStep++;
        }

        this.props.dispatchSetStep(nextStep, nextSubStep);
    }

    handleResetStep() {
        this.props.dispatchSetStep(1, 1);
    }

    handleChangeStep1(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });

        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }


    handleIsDrivableYes() {
        this.props.dispatchSetStep(5);
    }

    handleSubmitDamageStep1() {
        this.props.dispatchSetStep(6);
    }

    async handleSelectAll() {

        if (this.state.selectAll) {
            await this.setState({
                selectAll: false
            })
            this.props.dispatchSetSelectedAllFalse();
        }
        else {
            await this.setState({ selectAll: true })
            this.props.dispatchSetSelectedAllTrue();
        }
    }

    async handleSelectDamagePos(pos: string) {
        await this.setState({ damageIsInEdit: false });
        await this.props.dispatchIsInEdit(this.state.damageIsInEdit);
        switch (pos) {
            case 'front':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Front') : await this.props.dispatchShowSelectedDamageMB('Front');
                break;
            case 'frontLeft':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Front left') : await this.props.dispatchShowSelectedDamageMB('Front left');
                break;
            case 'frontRight':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Front right') : await this.props.dispatchShowSelectedDamageMB('Front right');
                break;
            case 'backLeft':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Back left') : await this.props.dispatchShowSelectedDamageMB('Back left');
                break;
            case 'backRight':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Back right') : await this.props.dispatchShowSelectedDamageMB('Back right');
                break;
            case 'back':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Back') : await this.props.dispatchShowSelectedDamageMB('Back');
                break;
        }
    }

    selectCauseOfCollision(event: any) {
        this.setState({
            causeOfCollision: event,
            hasCause: true,
        });
        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    checkStep1Answers() {
        if (this.state.hasCause && this.state.hasDate && this.state.hasTime) {
            this.setState({ Step1Disabled: false })
        }
    }

    handleChangeCause() {
        //todo
    }

    handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }

    handleChangeDateValue(date) {
        this.setState({
            startDate: date
        });
        this.props.dispatchSetDate(date);
        this.setState({ hasDate: true });
        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    async setTime(f12: any, f24: any) {
        await this.setState({ time12: f12, time24: f24 });
        await this.props.dispatchSetTime(f12, f24)
        this.props.dispatchSetTimeShow();
        this.setState({ hasTime: true });
        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    handleStepBack() {
        this.setState({ DescriptionWhatDisabled: false });
        const currentStep = this.props.claimSubmit.selectedClaimStep.step;
        this.props.dispatchSetStep(currentStep - 1);
    }

    async updateLatLngAdress(Lat, Lng, address) {
        lat = Lat
        lng = Lng
        await this.setState({ lat: Lat, lng: Lng, adressSelect: address })
    };

    handleAdressChange = address => {
        this.setState({ adressSelect: address });
    };

    handleAdressSelect = address => {
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => this.updateLatLngAdress(latLng.lat, latLng.lng, address))
            .catch();
    };

    async handleStep1Submit() {
        this.setState({ Step1Submitted: true })
        if (this.state.hasCause && this.state.hasDate && this.state.hasTime && this.state.name && this.state.contact) {
            this.props.dispatchSetStep(2);
        } else {
            this.setState({ Step1Disabled: true })
        }
    };

    //handleChange(e: any) {
    //    let name = e.target.name;
    //    let value = e.target.value;
    //    this.setState({ [name]: value });

    //    if (value.length >= 1) this.setState({ submitDisabled:false});
    //}

    handleChangeDescriptionWhere(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
        if (this.state.DescriptionWhereSubmitted) {
            this.checkSubmitDescriptionWhere();
        }
    }

    checkSubmitDescriptionWhere() {
        if (this.state.incidentDescriptionWhere) {
            this.setState({ DescriptionWhereDisabled: false });
        } else {
            this.setState({ DescriptionWhereDisabled: true });
        }
    }

    handleChangeDescriptionWhat(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });

        if (this.state.DescriptionWhatSubmitted) {
            this.checkWhatSubmit();
        }
    }

    checkWhatSubmit() {
        if (this.state.incidentDescriptionWhat) {
            this.setState({ DescriptionWhatDisabled: false });
        } else {
            this.setState({ DescriptionWhatDisabled: true });
        }
    }
    async handleSubmit(e: any) {

        var dateString = getDateString(this.props.claimSubmit.incidentDate, this.props.claimSubmit.time);

        var futureDateTimeCheck = await this.props.dispatchAction(checkDateTime(dateString));

        if (futureDateTimeCheck) {
            this.setState({
                hasFutureTime: futureDateTimeCheck.isFutureTime,
                hasFutureDate: futureDateTimeCheck.isFutureDate
            });
        }

        this.setState({ DescriptionWhereSubmitted: true })
        if (this.state.incidentDescriptionWhere) {
            await this.setState({ currentStep: 3 });
            this.props.dispatchSetStep(3);
        }
        else {
            this.setState({ DescriptionWhereDisabled: true })
        }
    }

    async Submit() {

        ///let claimNum = await this.props.dispatchSubmitClaim(this.state);

        // if (claimNum) {

        await this.setState({ currentStep: 3 });
        //this.props.redirectTo(SUBMIT_CLAIM_COMPLETE);
        //}
    }

    handeCanDrive(e: any) {
        if (e === "true") {
            this.setState({
                carDriveableSet: true,
                carRecoveredSet: true,
                isDriveable: true
            });
        }
        else {
            this.setState({
                carDriveableSet: true,
                carRecoveredSet: true,
                isDriveable: false
            });
        }

    }

    handeCanRecover(e: any) {
        if (e === "true") {
            this.setState({
                carRecoveredSet: true,
                carDriveableSet: true,
                isRecovered: true
            });
        }
        else {
            this.setState({
                carRecoveredSet: true,
                carDriveableSet: true,
                isRecovered: false
            });
        }
    }

    handleIndidentDateClicked() {
        document.body.addEventListener("click", this.handleClickAway);
        this.setState({
            isClosed: false,
        })
    }

    async mapReady(mapProps, map) {
        lat = map.center.lat()
        lng = map.center.lng()
        await this.setState({ lat: lat, lng: lng })
        map.addListener("click", (mapsMouseEvent) => {
            lat = mapsMouseEvent.latLng.toJSON().lat
            lng = mapsMouseEvent.latLng.toJSON().lng
            this.setState({ lat: lat, lng: lng })
        });
    }

    async handleClick(e: any) {
        await this.getIncidentTypes(e.target.id);
    }

    async handleNext(e: any) {
        await this.setState({ currentStep: 2 });
    }

    async handleNextMobile(e: any) {
        this.props.redirectTo(SUBMIT_CLAIM_DETAILS);
    }


    async handleIsDrivable(e: any) {
        this.setState({ DescriptionWhatSubmitted: true });
        if (this.state.incidentDescriptionWhat) {
            this.props.dispatchSetStep(7);
            await this.setState({
                currentStep: 4,
            })

            if (this.props.claimSubmit.selectedCover.product === 1 || this.props.claimSubmit.selectedCover.product === 2) {
                await this.setState({
                    isCar: true,
                })
                await this.props.dispatchSetIsCar(true);
            }
            else if (this.props.claimSubmit.selectedCover.product === 7) {
                await this.setState({
                    isCar: false,
                })
                await this.props.dispatchSetIsCar(false);
            }
            this.props.claimSubmit.isCar ? await this.props.dispatchGetClaimDamagePhotoTypes(6) : await this.props.dispatchGetClaimDamagePhotoTypes(7);
            this.props.dispatchSetStep(4);
        }
        else {
            this.setState({ DescriptionWhatDisabled: true });
        }
    }

    async getIncidentTypes(riskItemId) {
        await postToController(this.props.dispatch, 'GetEventTypes', JSON.stringify({ Parameter: riskItemId })).then(async (response) => {
            await this.setState({ eventTypeList: response });
            return true;
        })
    }

    async getClaimDamagePhotoTypes(riskItemTypeId: number) {
        await postToController(this.props.dispatch, 'GetClaimDamagePhotoTypes', JSON.stringify({ Parameter: riskItemTypeId })).then(async (response) => {
            await this.setState({ ClaimDamagePhotoTypesList: response });
            return true;
        })
    }

    async handleCoverSelection(e: any) {
        let coverItem = this.props.profile.personalPolicies[0].covers.filter(function (item) {
            return item.id == e
        })
        await this.getIncidentTypes(coverItem[0].id)
        await this.setState({ selectedCover: coverItem[0], selectedEvent: [] });
    }

    async handleCoverDropdownToggle(e: any) {
        await this.setState({
            coverToggle: !this.state.coverToggle
        });
    }

    handleRedirect() {
        this.props.redirectTo(SUBMIT_CLAIM);
    }

    async handleIncidentTypeDropdownToggle(e: any) {
        await this.setState({
            IncidentTypeToggle: !this.state.IncidentTypeToggle
        });
    }

    async handleIncidentSelection(e: any) {
        let eventType = this.props.claimSubmit.incidentEventList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ causeOfCollision: eventType[0], hasCause: true, });
    }

    async handleIncidentEventTypeSelection(e: any) {
        let incidentType = this.props.claimSubmit.incidentEventList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedIncidentType: incidentType[0] });
    }

    async handleIncidentToggle(e: any) {
        await this.setState({
            IncidentToggle: !this.state.IncidentToggle
        });
    }

    async handleRemoveFromList(item) {
        if (this.state.damageIsInEdit) {
            var newArr = this.props.claimSubmit.selectedDamagePhotoTypes.filter(x => x !== item);
            await this.props.dispatchSetSelectedDamagePhotoTypes(newArr);
            this.props.dispatchAddDamagePosition(this.props.claimSubmit.selectedDamagePhotoTypes);
        }
    }

    async handleEditSelectedDamage() {
        await this.setState({ damageIsInEdit: !this.state.damageIsInEdit });
        this.props.dispatchIsInEdit(this.state.damageIsInEdit);
    }

    checkDamageExtras(desc, isCar) {
        if (isCar) {
            return this.state.carDamageExtras.indexOf(desc) >= 0 ? true : false;
        }
        else {
            return this.state.mbDamageExtras.indexOf(desc) >= 0 ? true : false;
        }
    }

    checkChecked(e: any) {
        var set = this.props.claimSubmit.selectedDamagePhotoTypes.find((el => el.description == e));
        if (set) {
            return ("/my-policy/Images/Claims/grey-checkmark-checked.png");
        } else {
            return ("/my-policy/Images/Claims/grey-checkmark-unchecked.png");
        }
    }

    async setClaimDamagePhotoTypes(data: any) {
        var curVal = document.getElementById(data.description)?.getAttribute('src');
        if (curVal == "/my-policy/Images/Claims/grey-checkmark-unchecked.png") {
            document.getElementById(data.description)?.setAttribute('src', "/my-policy/Images/Claims/grey-checkmark-checked.png");
        }
        else {
            document.getElementById(data.description)?.setAttribute('src', "/my-policy/Images/Claims/grey-checkmark-unchecked.png");
        }
    }

    public render() {
        let extraDamagesList = <div></div>;
        extraDamagesList = this.props.claimSubmit.claimDamagePhotoTypes.filter((photoType => this.checkDamageExtras(photoType.description, this.props.claimSubmit.isCar)))
            .map((photoType) => {
                return <div className="row cover-divider-fnol mb-4 align-items-center">
                    <div className="col">
                        <p className="coverItems">{photoType.description}</p>
                    </div>
                    <div className="greyChecks align-self-center pr-5">
                        <img id={photoType.description} src={this.checkChecked(photoType.description)} onClick={() => this.setClaimDamagePhotoTypes(photoType)} />
                    </div>
                </div>
            });

        let incidentEventTypes = <div></div>;
        if (this.props.claimSubmit.incidentEventList) {
            incidentEventTypes = this.props.claimSubmit.incidentEventList.map((event) => {
                return <Dropdown.Item eventKey={event.id} key={event.id} value={event.id}>
                    {event.description}
                </Dropdown.Item>
            });
        }

        let damageDetailList = <div></div>;
        if (this.props.claimSubmit.selectedDamagePhotoTypes.length > 0) {
            damageDetailList = this.props.claimSubmit.selectedDamagePhotoTypes.map((photoType) => {
                return <div className="row cover-divider-fnol mb-5">
                    <div className="col">
                        <p className="coverItems">{photoType.description}</p>
                    </div>
                    <div className="greyChecks pr-5">
                        <img src={this.state.damageIsInEdit ? "/my-policy/Images/Claims/red-checkmark-cross.png" : "/my-policy/Images/Claims/grey-checkmark-checked.png"}
                            onClick={() => this.handleRemoveFromList(photoType)} />
                    </div>
                </div>
            });
        }

        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: FNOL, description: "Claims" }]

        return (
            <div >
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Submit a claim" />
                <div className="submit-a-claim-history-block mb-5">
                    <div className="container" id="SubmitClaim">
                        <div className="row">
                            <div className="col-2">
                                {/*{
                                 * this.props.claimSubmit.selectedClaimStep.step === 1 && <img className="mt-4" src='/my-policy/Images/FNOL/Progress/1.png' />}*/}
                                {this.props.claimSubmit.selectedClaimStep.step === 2 && <img className="mt-4" src='/my-policy/Images/FNOL/Progress/2.png' />}
                                {this.props.claimSubmit.selectedClaimStep.step === 3 && <img className="mt-4" src='/my-policy/Images/FNOL/Progress/3.png' />}
                                {this.props.claimSubmit.selectedClaimStep.step === 4 && <img className="mt-4" src='/my-policy/Images/FNOL/Progress/4.png' />}
                                {this.props.claimSubmit.selectedClaimStep.step === 5 && <img className="mt-4" src='/my-policy/Images/Claims/Numbers/5-red.png' />}
                                {this.props.claimSubmit.selectedClaimStep.step === 7 && <img className="mt-4" src='/my-policy/Images/FNOL/Progress/6.png' />}
                            </div>

                            <div className="col-10">
                                {this.props.claimSubmit.selectedClaimStep.step == 1 && <h3 className="claim-title pt-3 mb-1 mt-3">Claim info</h3>}
                                {this.props.claimSubmit.selectedClaimStep.step == 2 && <h3 className="claim-title pt-3 mb-1">Tell us where it <br />happened</h3>}
                                {this.props.claimSubmit.selectedClaimStep.step == 3 && <h3 className="claim-title pt-3 mb-1">Tell us how it <br />happened</h3>}

                                {this.props.claimSubmit.selectedClaimStep.step == 4 && this.state.isCar &&
                                    <h3 className="claim-title pt-3 mb-1">Is your car <br /> drivable</h3>
                                }

                                {this.props.claimSubmit.selectedClaimStep.step == 4 && !this.state.isCar &&
                                    <h3 className="claim-title pt-3 mb-1">Is your motorbike <br /> ridable</h3>
                                }
                                {this.props.claimSubmit.selectedClaimStep.step == 5 &&
                                    <h3 className="claim-title pt-3 mb-1 mt-3">Damage report</h3>
                                }
                                {this.props.claimSubmit.selectedClaimStep.step == 6 &&
                                    <h3 className="claim-title pt-3 mb-1 mt-3">Damage report: extras</h3>
                                }
                                {this.props.claimSubmit.selectedClaimStep.step == 7 &&
                                    <h3 className="claim-title pt-3 mb-1 mt-3">Take photos</h3>
                                }
                            </div>
                            
                        </div>

                        <hr />

                        {this.props.claimSubmit.selectedClaimStep.step === 1 &&
                            <FnolStep1 />
                        }
                        {this.props.claimSubmit.selectedClaimStep.step === 2 &&
                            <FnolStep2 />
                        }
                        <button onClick={() => this.handleResetStep()}>Reset Step</button>

                        <div className="container pb-5">
                            <p>Before we can look into your claim, we need a few details</p>

                            <div className={'form-group mb-5 pt-4' + (this.state.Step1Submitted && !this.state.causeOfCollision ? ' has-error' : '')}>
                                <Dropdown id="ChooseItem-fnol"
                                    onSelect={this.handleIncidentSelection}
                                    onToggle={this.handleIncidentToggle}
                                    className="dopdownCause">
                                    <Dropdown.Toggle id="dropdown-basic" >
                                        {this.state.causeOfCollision &&
                                            <>
                                                <div className="row black">
                                                    <div className="text-left col dropdown-inline-icon">
                                                        <p className="title mb-1">Cause of collision</p>
                                                        <p className="hide-overflow pt-3 collision-line" id="selectedCollision">{this.state.causeOfCollision.description}</p>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {!this.state.causeOfCollision &&
                                            <>
                                                <div className="row black">
                                                    <div className="text-left col dropdown-inline-icon">
                                                        <h4>Cause of collision</h4>
                                                    </div>
                                                </div>
                                                <hr id="wide-HR" />
                                            </>
                                        }
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu title="Select type of incident" id="nav-dropdown-type">
                                        {incidentEventTypes}
                                    </Dropdown.Menu>
                                </Dropdown>
                                {this.state.Step1Submitted && !this.state.causeOfCollision &&
                                    <div className="help-block">Event type is required</div>
                                }
                            </div>


                            <div className={'new-time-picker-test form-group mb-4 pt-4"' + (this.state.Step1Submitted && !this.state.hasDate ? ' has-error' : '')} onClick={this.checkTimeToggle}>
                                {this.state.hasDate &&
                                    <p className="mb-1">Incident date</p>
                                }
                                <ModernDatepicker
                                    date={this.state.startDate}
                                    format={'DD-MM-YYYY'}
                                    showBorder
                                    onChange={(date) => this.handleChangeDateValue(date)}
                                    placeholder='Incident date'
                                    className="calendar-inline-icon"
                                    maxDate={this.state.maxDate}
                                    id='fnol-datepicker'
                                />
                                {this.state.Step1Submitted && !this.state.hasDate &&
                                    <div className="help-block">Date is required</div>
                                }
                            </div>
                            <div className={'form-group mb-3 pt-4"' + (this.state.Step1Submitted && !this.state.hasTime ? ' has-error' : '')}>
                                {this.state.hasTime &&
                                    <p className="mb-1">Incident time</p>
                                }

                                <input type="button" disabled={this.props.isClosed} className="form-control clientName pl-0 text-left watch-inline-icon" value={this.state.hasTime ? this.props.claimSubmit.timeDisplay : 'Incident time'} onClick={this.handleIndidentDateClicked} />
                                <div className={this.props.claimSubmit.IsIncidentDateClicked ? 'visible' : 'invisible'} onMouseLeave={this.setMouseOut} onMouseEnter={this.setMouseIn}>
                                    <div>
                                        <TimeKeeper
                                            time={this.props.claimSubmit.timeDisplay}
                                            switchToMinuteOnHourSelect
                                            onChange={(newTime) => this.handleTimeChange(newTime.formatted12, newTime.formatted24)}
                                            doneButton={(newTime) => (
                                                <div
                                                    className="btn btn-solid-red process"
                                                    onClick={() => this.setTime(newTime.formatted12, newTime.formatted24)}
                                                >
                                                    Close
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                                {this.state.Step1Submitted && !this.state.hasTime &&
                                    <div className="help-block">Time is required</div>
                                }
                            </div>
                            <div className="pt-5 pb-3">
                                <h4>Who should we chat to about this claim?</h4>
                            </div>
                            <div className="mb-3">
                                <p className="mb-1">Name</p>
                                <input className="form-control clientName pl-0" name="name" value={this.state.name} onChange={this.handleChangeStep1} />
                                {this.state.Step1Submitted && !this.state.name &&
                                    <div className="help-block">Name is required</div>
                                }
                            </div>
                            <div className="mb-5">
                                <p className="mb-1">Phone no.</p>
                                <input type="text" className="form-control clientName pl-0" name="contact" value={this.state.contact} onChange={this.handleChangeStep1} />
                                {this.state.Step1Submitted && !this.state.contact &&
                                    <div className="help-block">Contact details are required</div>
                                }
                            </div>
                            <div>
                                <div className="row mt-3">

                                    <div className="col-12">
                                        <button className="btn btn-solid-red mt-3 w-100" disabled={this.state.Step1Disabled} onClick={this.handleStep1Submit}>Next</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/*Keeping this for reference*/}
                        {/*}*/}

                        {/*{this.props.claimSubmit.selectedClaimStep.step === 2 &&*/}
                        {/*    <div className={'form-group mb-2' + (this.state.DescriptionWhereSubmitted && !this.state.incidentDescriptionWhere ? ' has-error' : '')}>*/}
                        {/*        <p className="mt-4 mb-5">Where did this incident take place (share as much info as possible) </p>*/}
                        {/*        <textarea id="incidentDescriptionWhere" name="incidentDescriptionWhere" rows={4} cols={50} className="form-control w3review" placeholder="Tap here to start typing" value={this.state.incidentDescriptionWhere} onChange={this.handleChangeDescriptionWhere} />*/}
                        {/*        {this.state.DescriptionWhereSubmitted && !this.state.incidentDescriptionWhere &&*/}
                        {/*            <div className="help-block">Description of where it happened is required</div>*/}
                        {/*        }*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{this.props.claimSubmit.selectedClaimStep.step === 3 &&*/}
                        {/*    <div className={'form-group mb-2' + (this.state.DescriptionWhatSubmitted && !this.state.incidentDescriptionWhat ? ' has-error' : '')}>*/}

                        {/*        <p className="mt-4 mb-5">How did this happen (share as much info as possible)</p>*/}
                        {/*        <textarea id="incidentDescriptionWhat" name="incidentDescriptionWhat" rows={4} cols={50} className="form-control w3review" placeholder="Tap here to start typing" onChange={this.handleChangeDescriptionWhat} />*/}
                        {/*        {this.state.DescriptionWhatSubmitted && !this.state.incidentDescriptionWhat &&*/}
                        {/*            <div className="help-block">Description  of what happened is required</div>*/}
                        {/*        }*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{this.props.claimSubmit.selectedClaimStep.step === 4 && this.state.isCar &&*/}
                        {/*    <>*/}
                        {/*        <p>*/}
                        {/*            <strong>'Drivable'</strong> means you can drive your vehicle without causing it more damage, or putting yourself at risk.*/}
                        {/*    </p>*/}
                        {/*        <p>*/}
                        {/*            <strong>Please note:</strong> If there's even 1 requirement on this list that your car doesn't meet, it's not drivable.*/}
                        {/*    </p>*/}
                        {/*        <div className="pt-2 blue">*/}
                        {/*            <strong>Your car is drivable if:</strong>*/}
                        {/*            <ul className="pt-2" id="drivableChecksMobile">*/}
                        {/*                <li>It isn't smoking or leaking oil.</li>*/}
                        {/*                <li className="pt-4">There are no flashing engine lights. You'll need to switch on your car to check this.</li>*/}
                        {/*                <li className="pt-4">The tyres are all aligned.</li>*/}
                        {/*                <li className="pt-4">The break lights are working and the window glass is still intact.</li>*/}
                        {/*                <li className="pt-4">There are no knocks or clicks coming from the engine.</li>*/}
                        {/*                <li className="pt-4">All doors (including the boot) can open.</li>*/}
                        {/*                <li className="pt-4">Your airbag didn't deploy.</li>*/}
                        {/*            </ul>*/}
                        {/*        </div>*/}
                        {/*    </>*/}
                        {/*}*/}

                        {/*{this.props.claimSubmit.selectedClaimStep.step === 4 && !this.state.isCar &&*/}
                        {/*    <>*/}
                        {/*        <p>*/}
                        {/*            <strong>'Ridable'</strong> means you can ride your motorbike without causing it more damage, or putting yourself at risk.*/}
                        {/*    </p>*/}
                        {/*        <p>*/}
                        {/*            <strong>Please note:</strong> If there's even 1 requirement on this list that your motorbike doesn't meet, it's not ridable.*/}
                        {/*    </p>*/}
                        {/*        <div className="pt-2 blue">*/}
                        {/*            <strong>Your motorbike is ridable if:</strong>*/}
                        {/*            <ul className="pt-2" id="drivableChecksMobile">*/}
                        {/*                <li>The wheels are not wobbly.</li>*/}
                        {/*                <li className="pt-4">The front forks are not gouged or bent.</li>*/}
                        {/*                <li className="pt-4">The handlebars are not bent or crooked.</li>*/}
                        {/*                <li className="pt-4">The petrol tank isn't scratched, dented or leaking.</li>*/}
                        {/*                <li className="pt-4">The frame isn't bent.</li>*/}
                        {/*                <li className="pt-4">The windshield isn't broken or cracked.</li>*/}
                        {/*            </ul>*/}
                        {/*        </div>*/}
                        {/*    </>*/}
                        {/*}*/}

                        {/*{this.props.claimSubmit.selectedClaimStep.step === 5 &&*/}
                        {/*    <>*/}
                        {/*        <p className="pt-3">Select the green dots on the image below to show us exactly where the damage is</p>*/}
                        {/*        <p className="pt-2">*/}
                        {/*            <span className="pr-4"><img className="pr-2" src="/my-policy/Images/FNOL/Progress/progress-circle-green.png" /><strong>Not damaged</strong></span>*/}
                        {/*            <span className="pr-5"><img className="pr-2" src="/my-policy/Images/FNOL/Progress/progress-circle-red.png" /><strong>Damaged</strong></span>*/}
                        {/*        </p>*/}
                        {/*        <div className="container pt-5 pb-5">*/}
                        {/*            {this.props.claimSubmit.isCar &&*/}
                        {/*                <>*/}
                        {/*                    <div className="text-center damage-report-car-container">*/}
                        {/*                        <strong className="pb-3">Front</strong><br /><br />*/}
                        {/*                        <img className='img-fluid' src="/my-policy/Images/FNOL/damage-report-car.png" /><br /><br />*/}
                        {/*                        <strong className="pt-3">Back</strong>*/}
                        {/*                        <img id="front-car" onClick={() => this.handleSelectDamagePos('front')} src={this.props.claimSubmit.damageListCar.damageFront ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                        <img id="left-front-car" onClick={() => this.handleSelectDamagePos('frontLeft')} src={this.props.claimSubmit.damageListCar.damageFrontLeft ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                        <img id="left-back-car" onClick={() => this.handleSelectDamagePos('backLeft')} src={this.props.claimSubmit.damageListCar.damageBackLeft ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                        <img id="right-front-car" onClick={() => this.handleSelectDamagePos('frontRight')} src={this.props.claimSubmit.damageListCar.damageFrontRight ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                        <img id="right-back-car" onClick={() => this.handleSelectDamagePos('backRight')} src={this.props.claimSubmit.damageListCar.damageBackRight ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                        <img id="back-car" onClick={() => this.handleSelectDamagePos('back')} src={this.props.claimSubmit.damageListCar.damageBack ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                    </div>*/}
                        {/*                </>*/}
                        {/*            }*/}

                        {/*            {!this.props.claimSubmit.isCar &&*/}
                        {/*                <>*/}
                        {/*                    <div className="text-center damage-report-mb-container">*/}
                        {/*                        <img src="/my-policy/Images/FNOL/damage-report-motorcycle.png" />*/}
                        {/*                        <img id="front-mb" onClick={() => this.handleSelectDamagePos('front')} src={this.props.claimSubmit.damageListCar.damageFront ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                        <img id="left-front-mb" onClick={() => this.handleSelectDamagePos('frontLeft')} src={this.props.claimSubmit.damageListCar.damageFrontLeft ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                        <img id="left-back-mb" onClick={() => this.handleSelectDamagePos('backLeft')} src={this.props.claimSubmit.damageListCar.damageBackLeft ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                        <img id="right-front-mb" onClick={() => this.handleSelectDamagePos('frontRight')} src={this.props.claimSubmit.damageListCar.damageFrontRight ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                        <img id="right-back-mb" onClick={() => this.handleSelectDamagePos('backRight')} src={this.props.claimSubmit.damageListCar.damageBackRight ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                        <img id="back-mb" onClick={() => this.handleSelectDamagePos('back')} src={this.props.claimSubmit.damageListCar.damageBack ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />*/}
                        {/*                    </div>*/}
                        {/*                </>*/}
                        {/*            }*/}
                        {/*        </div>*/}
                        {/*        <div className="text-center">*/}
                        {/*            <span className="checkAll"><img onClick={this.handleSelectAll} className="pr-3" src={this.state.selectAll ? '/my-policy/Images/FNOL/Rectangle-checked.png' : '/my-policy/Images/FNOL/Rectangle-uncheked.png'} />Select all</span>*/}
                        {/*        </div>*/}

                        {/*        {this.props.claimSubmit.selectedDamagePhotoTypes.length > 0 &&*/}
                        {/*            <>*/}
                        {/*                <hr />*/}
                        {/*                <div className="row pt-4 pb-4">*/}
                        {/*                    <div className="col">*/}
                        {/*                        <h3>Damage detail</h3>*/}
                        {/*                    </div>*/}
                        {/*                    <div className="edit-pencil pr-5">*/}
                        {/*                        <img className="arrow" src={this.state.damageIsInEdit ? "/my-policy/Images/Claims/Edit-pen-red.png" : "/my-policy/Images/Claims/Edit-pen.png"} onClick={this.handleEditSelectedDamage} />*/}
                        {/*                    </div>*/}
                        {/*                </div>*/}
                        {/*                {damageDetailList}*/}
                        {/*            </>*/}
                        {/*        }*/}
                        {/*    </>*/}
                        {/*}*/}
                        {/*{this.props.claimSubmit.selectedClaimStep.step === 6 &&*/}
                        {/*    <>*/}
                        {/*        <p className="pt-3 mb-4">Were any of these areas damaged in the process (if not, just select 'Next')</p>*/}
                        {/*        {extraDamagesList}*/}
                        {/*        <div className='mt-5'>*/}
                        {/*            <p className='mb-4'>Can't find what you want on this list? Specify which extras were damaged, here:</p>*/}
                        {/*            <textarea id="DamageExtrasText" name="incidentDescriptionWhere" rows={4} cols={50} className="form-control w3review" placeholder="Tap here to start typing" onChange={this.handleChangeDescriptionWhere} />*/}

                        {/*        </div>*/}
                        {/*    </>*/}
                        {/*}*/}

                        {/*{this.props.claimSubmit.selectedClaimStep.step === 2 &&*/}
                        {/*    <>*/}
                        {/*        <div id="GoogleMap" className="pt-3">*/}
                        {/*            <p className="mb-1">Please also share the Google maps location if you can (we totes understand if you can't find it)</p>*/}
                        {/*            <div>*/}
                        {/*                <PlacesAutocomplete*/}
                        {/*                    value={this.state.adressSelect}*/}
                        {/*                    onChange={this.handleAdressChange}*/}
                        {/*                    onSelect={this.handleAdressSelect}*/}
                        {/*                    searchOptions={{ componentRestrictions: { country: "za" } }}*/}
                        {/*                >*/}
                        {/*                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (*/}
                        {/*                        <div>*/}
                        {/*                            <input*/}
                        {/*                                {...getInputProps({*/}
                        {/*                                    placeholder: 'Find Location',*/}
                        {/*                                    className: ' searchboxFNOL mb-5 w-100',*/}
                        {/*                                })}*/}
                        {/*                            />*/}
                        {/*                            <div className="autocomplete-dropdown-container">*/}
                        {/*                                {loading && <div>Loading...</div>}*/}
                        {/*                                {suggestions.map(suggestion => {*/}
                        {/*                                    const className = suggestion.active*/}
                        {/*                                        ? 'suggestion-item--active'*/}
                        {/*                                        : 'suggestion-item';*/}
                        {/*                                    // inline style for demonstration purpose*/}
                        {/*                                    const style = suggestion.active*/}
                        {/*                                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }*/}
                        {/*                                        : { backgroundColor: '#ffffff', cursor: 'pointer' };*/}
                        {/*                                    return (*/}
                        {/*                                        <div*/}
                        {/*                                            {...getSuggestionItemProps(suggestion, {*/}
                        {/*                                                className,*/}
                        {/*                                                style,*/}
                        {/*                                            })}*/}
                        {/*                                        >*/}
                        {/*                                            <span>{suggestion.description}</span>*/}
                        {/*                                        </div>*/}
                        {/*                                    );*/}
                        {/*                                })}*/}
                        {/*                            </div>*/}
                        {/*                        </div>*/}
                        {/*                    )}*/}
                        {/*                </PlacesAutocomplete>*/}
                        {/*            </div>*/}
                        {/*            <Map google={this.props.google}*/}
                        {/*                centerAroundCurrentLocation*/}
                        {/*                center={{ lat: this.state.lat, lng: this.state.lng }}*/}
                        {/*                onReady={this.mapReady}*/}
                        {/*                containerStyle={{*/}
                        {/*                    position: 'relative',*/}
                        {/*                    overflow: 'hidden',*/}
                        {/*                    width: '100%',*/}
                        {/*                    height: '271px',*/}
                        {/*                    borderRadius: '8px'*/}
                        {/*                }}>*/}
                        {/*                <Marker*/}
                        {/*                    // @ts-ignore*/}
                        {/*                    position={{ lat: this.state.lat, lng: this.state.lng }}*/}
                        {/*                    draggable={false}*/}
                        {/*                    title="Accident location"*/}
                        {/*                />*/}
                        {/*            </Map>*/}
                        {/*        </div>*/}

                        {/*    </>*/}
                        {/*}*/}

                        {/*{this.props.claimSubmit.selectedClaimStep.step === 7 &&*/}
                        {/*    <>*/}

                        {/*    <div className='mt-5'>*/}
                        {/*        <p>Please take good quality photos by:</p>*/}
                        {/*        <ul>*/}
                        {/*            <li>Checking that they're not blurred.</li>*/}
                        {/*            <li>Using good lighting</li>*/}
                        {/*        </ul>*/}

                        {/*        <TakePhotos />*/}

                        {/*        </div>*/}
                        {/*    </>*/}
                        {/*}*/}
                        <div>
                            {this.props.claimSubmit.selectedClaimStep.step === 2 &&
                                <>
                                    <button className="btn btn-solid-red mt-3 col-12" disabled={this.state.DescriptionWhereDisabled} onClick={this.handleSubmit}>Next</button>
                                    <button className="btn btn-outline-red mr-2 mb-5 col-12 mb-4 mt-3 w-100" onClick={this.handleRedirect}>Back</button>
                                </>
                            }
                            {this.props.claimSubmit.selectedClaimStep.step === 3 &&
                                <>
                                    <button className="btn btn-solid-red mt-3 col-12" disabled={this.state.DescriptionWhatDisabled} onClick={this.handleIsDrivable}>Next</button>
                                    <button className="btn btn-outline-red mr-2 mb-5 col-12 mb-4 mt-3 w-100" onClick={this.handleRedirect}>Back</button>
                                </>
                            }
                            {this.props.claimSubmit.selectedClaimStep.step === 4 &&
                                <>
                                    <button className="btn btn-solid-red  mt-4 col-12" onClick={this.handleIsDrivableYes}>Yes, I {this.state.isCar ? 'can drive my car' : 'can ride my motorbike'}</button>
                                    <button className="btn btn-outline-red mr-2 mb-5 col-12 mb-4 mt-3 w-100" onClick={this.props.handleNotDrivableModal}>No, I {this.state.isCar ? "can't drive my car" : "can't ride my motorbike"}</button>
                                </>
                            }
                            {this.props.claimSubmit.selectedClaimStep.step === 5 &&
                                <>
                                    <button className="btn btn-solid-red  mt-4 col-12" disabled={(this.props.claimSubmit.selectedDamagePhotoTypes.length == 0 && !this.state.selectAll) ? true : false} onClick={this.handleSubmitDamageStep1}>Next</button>
                                    <button className="btn btn-outline-red mr-2 mb-5 col-12 mb-4 mt-3 w-100" onClick={this.handleStepBack}>Back</button>
                                </>
                            }

                            {this.props.claimSubmit.selectedClaimStep.step === 6 &&
                                <>
                                    <button className="btn btn-solid-red  mt-4 col-12" disabled={(this.props.claimSubmit.selectedDamagePhotoTypes.length == 0 && !this.state.selectAll) ? true : false} onClick={this.handleNextStep}>Next</button>
                                    <button className="btn btn-outline-red mr-2 mb-5 col-12 mb-4 mt-3 w-100" onClick={this.handleNextStep}>Back</button>
                                </>
                            }

                            {this.props.claimSubmit.selectedClaimStep.step === 7 &&
                                <>
                                    <button className="btn btn-solid-red  mt-4 col-12" disabled={(this.props.claimSubmit.selectedDamagePhotoTypes.length == 0 && !this.state.selectAll) ? true : false} onClick={this.handleSubmitDamageStep1}>Next</button>
                                    <button className="btn btn-outline-red mr-2 mb-5 col-12 mb-4 mt-3 w-100" onClick={this.handleStepBack}>Back</button>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSubmitClaim: (data) => dispatch(submitClaimMobile(data)),
        dispatchLocation: (lat, lng) => dispatch(setLocation(lat, lng)),
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        handleNotDrivableModal: () => dispatch(showDrivableNoModal()),
        dispatchSetDate: (data) => dispatch(setDate(data)),
        dispatchSetTime: (time12, time24) => dispatch(setTime(time12, time24)),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchSetIsCar: (isCar) => dispatch(setIsCar(isCar)),
        dispatchGetClaimDamagePhotoTypes: (riskItemType) => dispatch(getClaimDamagePhotoTypes(riskItemType)),
        dispatchShowSelectedDamageCar: (position) => dispatch(showSelectedDamageCar(position)),
        dispatchSetSelectedDamagePhotoTypes: (riskItemType) => dispatch(setSelectedDamagePhotoTypes(riskItemType)),
        dispatchAddDamagePosition: (pos) => dispatch(setDamagePosition(pos)),
        dispatchSetSelectedAllTrue: () => dispatch(setSelectedAllTrue()),
        dispatchSetSelectedAllFalse: () => dispatch(setSelectedAllFalse()),
        dispatchShowSelectedDamageMB: (position) => dispatch(showSelectedDamageMB(position)),
        dispatchIsInEdit: (isEdit) => dispatch(setIsInEdit(isEdit)),
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps)(ClaimDetails);

export default GoogleApiWrapper({
    apiKey: 'AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8'
})(connector);